import { useContext } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'clsx';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './messagePopover.module.scss';

export function MessagePopover({ message, showing, isPlayerOpen, className }) {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);
  if (!message) {
    return null;
  }
  return (
    <div
      className={classNames(
        css.message,
        {
          [css.show]: showing,
          [css.abovePlayer]: isPlayerOpen,
        },
        className,
      )}
    >
      {getLocalizedText(message)}
    </div>
  );
}

MessagePopover.propTypes = {
  showing: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  isPlayerOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export function mapStateToProps({ messagePopover }) {
  return messagePopover;
}

export default connect(mapStateToProps)(MessagePopover);
